import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Register = () => {
  const navigate = useNavigate();
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [isPending, setIsPending] = useState(false);
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showSenha, setShowSenha] = useState(false);
  const [showConfirmarSenha, setShowConfirmarSenha] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (senha !== confirmarSenha) {
      setErrorMessage('As senhas não coincidem.');
      return;
    }
    setIsPending(true);

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/users/register`, {
        nome,
        email,
        senha,
      });

      navigate('/login', {
        state: {
          successMessage: 'Conta criada com sucesso. Faça login para continuar.',
        },
      });
    } catch (err) {
      setErrorMessage(
        err.response?.data?.msg || 'Não foi possível cadastrar o usuário.'
      );
    } finally {
      setIsPending(false);
    }
  };

  return (
    <section className="page-section auth-page">
      <div className="auth-layout">
        <div className="surface-card auth-panel auth-panel--warm">
          <span className="eyebrow">Nova conta</span>
          <h1 className="section-title">Crie um espaço bonito e prático para suas compras.</h1>
          <p className="section-copy">
            Em poucos passos você ganha um painel responsivo, com categorias,
            totais, compartilhamento e tema adaptável.
          </p>
          <ul className="feature-list">
            <li>Cadastre listas para casa, trabalho ou compras recorrentes.</li>
            <li>Alterne entre itens por unidade ou peso.</li>
            <li>Gerencie tudo em desktop ou celular com o mesmo fluxo.</li>
          </ul>
        </div>

        <div className="surface-card auth-card">
          <div className="section-heading">
            <span className="eyebrow">Cadastro</span>
            <h2 className="section-subtitle">Abra sua conta</h2>
          </div>

          {errorMessage && (
            <div className="notice notice--error" role="alert">
              {errorMessage}
            </div>
          )}

          <form onSubmit={onSubmit} autoComplete="off" className="auth-form">
            <label className="field" htmlFor="nome">
              <span className="field-label">Nome</span>
              <input
                id="nome"
                type="text"
                className="field-input"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required
                autoFocus
              />
            </label>

            <label className="field" htmlFor="email">
              <span className="field-label">E-mail</span>
              <input
                id="email"
                type="email"
                className="field-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                required
              />
            </label>

            <label className="field" htmlFor="senha">
              <span className="field-label">Senha</span>
              <div className="password-field">
                <input
                  id="senha"
                  type={showSenha ? 'text' : 'password'}
                  className="field-input"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  autoComplete="new-password"
                  required
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowSenha((currentState) => !currentState)}
                  aria-label={showSenha ? 'Ocultar senha' : 'Mostrar senha'}
                >
                  <i className={`bi ${showSenha ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                </button>
              </div>
            </label>

            <label className="field" htmlFor="confirmarSenha">
              <span className="field-label">Confirmar senha</span>
              <div className="password-field">
                <input
                  id="confirmarSenha"
                  type={showConfirmarSenha ? 'text' : 'password'}
                  className="field-input"
                  value={confirmarSenha}
                  onChange={(e) => setConfirmarSenha(e.target.value)}
                  autoComplete="new-password"
                  required
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() =>
                    setShowConfirmarSenha((currentState) => !currentState)
                  }
                  aria-label={
                    showConfirmarSenha ? 'Ocultar confirmação' : 'Mostrar confirmação'
                  }
                >
                  <i
                    className={`bi ${
                      showConfirmarSenha ? 'bi-eye-slash' : 'bi-eye'
                    }`}
                  ></i>
                </button>
              </div>
            </label>

            <div className="auth-actions">
              <button
                type="submit"
                className="primary-button button-block"
                disabled={isPending}
              >
                {isPending ? (
                  <>
                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    Criando conta...
                  </>
                ) : (
                  'Cadastrar'
                )}
              </button>
            </div>
          </form>

          <p className="auth-footer">
            Já tem uma conta?{' '}
            <Link to="/login" className="inline-link">
              Faça login
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Register;
